export function isEmptyString(string: string) {
  return !string.trim();
}
